<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { FeatureAskQuestionForm } from '~/components/feature/ask-question-form'

const { t } = useI18n()

const breadcrumbs = computed(() => [
  { title: t('page.discussions.create.breadcrumbs_discussions'), url: '/discussions' },
  { title: t('page.discussions.create.breadcrumbs_create'), url: '/discussions/create' }
])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentBlock
        variant="white"
        heading-tag="h1"
        :heading-text="$t('page.discussions.create.heading')"
        role="main"
      >
        <p>
          {{ $t('page.discussions.create.description') }}
        </p>
        <FeatureAskQuestionForm />
      </ContentBlock>
    </Container>
  </Main>
</template>
